export const diasDaSemana = [
  { label: 'Segunda', mostrar: true },
  { label: 'Terça', mostrar: true },
  { label: 'Quarta', mostrar: true },
  { label: 'Quinta', mostrar: true },
  { label: 'Sexta', mostrar: true },
  { label: 'Sábado', mostrar: false },
  { label: 'Domingo', mostrar: false }
]
